<app-card-content [border]="false" icon="pi pi-file" title="Anotações" subtitle="Histórico de anotações do prestador"
    ><div card-header><app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" /></div>
    <app-tab-container [(selected)]="selected" [options]="options" [useHeader]="false" (onChanged)="alterarAba($event.value)"
        ><app-tab-content value="CONTRATO_SOCIAL"><app-custom-table [metadata]="metadata" [data]="linhasTabela()" [columnOrder]="columnOrder" [loading]="loading()" [totalRecords]="linhas().length" /></app-tab-content
        ><app-tab-content value="DIVIDA_ATIVA"><app-custom-table [metadata]="metadata" [data]="linhasTabela()" [columnOrder]="columnOrder" [loading]="loading()" [totalRecords]="linhas().length" /></app-tab-content
        ><app-tab-content value="LANCAMENTOS"><app-custom-table [metadata]="metadata" [data]="linhasTabela()" [columnOrder]="columnOrder" [loading]="loading()" [totalRecords]="linhas().length" /></app-tab-content
        ><app-tab-content value="PORTAL_SERVICOS"><app-custom-table [metadata]="metadata" [data]="linhasTabela()" [columnOrder]="columnOrder" [loading]="loading()" [totalRecords]="linhas().length" /></app-tab-content
        ><app-tab-content value="GERAIS"><app-custom-table [metadata]="metadata" [data]="linhasTabela()" [columnOrder]="columnOrder" [loading]="loading()" [totalRecords]="linhas().length" /></app-tab-content></app-tab-container
></app-card-content>

<p-dialog
    appDialogoPadrao="pi pi-info-circle"
    descricao="Anotação registrada no cadastro."
    header="Visualizar anotação"
    [visible]="modalVisualizacaoAnotacao()"
    (visibleChange)="modalVisualizacaoAnotacao.set($event)"
    [style]="{ width: '42rem', maxWidth: '95vw' }"
    (onHide)="fecharVisualizacaoAnotacao()"
>
    @if (anotacaoVisualizacao(); as anotacao) {
        <section class="anotacao-dialog">
            <div class="anotacao-dialog-data">
                <span class="anotacao-dialog-label">Data</span>
                <strong>{{ anotacao.data || 'Não informada' }}</strong>
            </div>

            <div class="anotacao-dialog-texto">
                <span class="anotacao-dialog-label">Anotação</span>
                <p>{{ anotacao.historico || 'Sem texto informado.' }}</p>
            </div>
        </section>
    }

    <ng-template pTemplate="footer">
        <p-button label="Fechar" icon="pi pi-times" severity="secondary" (onClick)="fecharVisualizacaoAnotacao()"></p-button>
    </ng-template>
</p-dialog>

<app-anotacao-nova [showDialog]="modalNovaAnotacao()" (showDialogChange)="modalNovaAnotacao.set($event)" [pessoa]="pessoa()" [salvando]="salvandoAnotacao()" (anotacaoCriada)="onAnotacaoCriada($event)" />
